<template>
  <div>
    <div class="block__wrapper" id="element">
      <div class="block__content">
        <h2 class="alignCenter">Amiraalin keikoilla soitettua:</h2>

        <div class="mysteryBox">
          <p class="alignCenter">
            {{ randomArtist }} <span v-if="!loading"> - </span> {{ randomSong }}
          </p>
          <div class="loader" v-if="loading"></div>
        </div>
        <div class="alignCenter mysteryBox__links">
          <a
            class="clickable "
            v-on:click="generateRandomSong()"
            v-if="!loading"
            >Selaa kappaleita</a
          >
          <p v-else>Haetaan...</p>
        </div>

        <h4 class="alignCenter marginTop--large">
          Ahtion settilistalla on ollut mm. seuraavia artisteja:
        </h4>
        <div class="band__wrapper">
          <div
            v-for="(band, index) in sortedBands"
            :key="index"
            v-if="index < showResults"
            class="band__label"
          >
            <p class="primary">{{ band.name }}</p>
          </div>
        </div>

        <div class="marginTop--medium">
          <div class="button" v-on:click="toggleResultFilter()" v-if="showMore">
            Näytä lisää
          </div>
          <div
            class="button"
            v-scroll-to="'#element'"
            v-on:click="toggleResultFilter()"
            v-else
          >
            Näytä vähemmän
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bands } from "../components/BandsTable.js"; // Tuo taulukkodata

export default {
  name: "Songs",
  data() {
    return {
      loading: false,
      isMobile: false, // Alustetaan isMobile arvolla false
      randomArtist: "",
      randomSong: "",
      showResults: 12,
      showMore: true, // "Näytä lisää -teksti"
      bands: bands
    };
  },
  mounted() {
    this.generateRandomSong();
  },
  computed: {
    sortedBands: function() {
      return this.bands.slice().sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  },
  mounted() {
    this.countStats(); // Kutsutaan countStats-funktiota, kun komponentti on ladattu
    this.generateRandomSong();

    // Lisätään tapahtumankäsittelijä ikkunan koon muutoksille
    window.addEventListener("resize", this.checkIsMobile);

    // Kutsutaan tarkistusta aluksi
    this.checkIsMobile();
  },
  beforeDestroy() {
    // Poistetaan tapahtumankäsittelijä komponentin purkamisen yhteydessä
    window.removeEventListener("resize", this.checkIsMobile);
  },
  methods: {
    // Funktio, joka tarkistaa selaimen leveyden ja päivittää isMobile-arvon
    checkIsMobile() {
      this.isMobile = window.innerWidth < 800;
      console.log("Onko mobiili " + this.isMobile);
    },

    toggleResultFilter: function() {
      var that = this;

      if (this.showResults < this.bands.length) {
        this.showResults = this.bands.length;
        this.showMore = false;
      } else {
        setTimeout(function() {
          that.showResults = 12;
          this.showMore = true;
        }, 400);
      }
    },

    generateRandomSong: function() {
      this.loading = true;
      this.randomArtist = "";
      this.randomSong = "";
      var that = this;
      var timeOut = Math.floor(Math.random() * 1200) + 750;
      setTimeout(function() {
        that.loading = false;
        var randomArtist = Math.floor(Math.random() * that.bands.length);
        that.randomArtist = that.bands[randomArtist].name;
        var randomSong = Math.floor(
          Math.random() * that.bands[randomArtist].songs.length
        );
        that.randomSong = that.bands[randomArtist].songs[randomSong].title;
      }, timeOut);
    },
    countStats: function() {
      let finnishCount = 0;
      let englishCount = 0;
      let other = 0;

      for (let i = 0; i < this.bands.length; i++) {
        if (this.bands[i].language === "Finnish") {
          finnishCount++;
        } else if (this.bands[i].language === "English") {
          englishCount++;
        } else {
          other++;
        }
      }
      console.log("Suomenkielisiä artisteja:", finnishCount);
      console.log("Englanninkielisiä artisteja:", englishCount);
      console.log("Muut kielet:", other);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1:first-child {
  margin: 0;
}

.block__wrapper {
  width: 100%;
  min-height: 50vh;
  background-color: var(--light-background);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 4rem 0;
}
.block__content {
  width: 75vw;
  padding: 2rem;
}
.band__wrapper {
  display: flex;
  flex-wrap: wrap;
}
.band__label {
  background-color: var(--lighter-background);
  padding: 0.25rem;
  border: 2px solid var(--light-background);
  width: 25%;
  text-align: center;
}

.mysteryBox {
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.mysteryBox__links a {
  margin: 0;
}
.mysteryBox__links p {
  margin: 0;
}

@media (max-width: 900px) {
  .block__content {
    width: 100%;
    text-align: center;
  }

  .band__label {
    width: 50%;
  }
}

@media (max-width: 600px) {
  .band__label {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Songs.vue